export const minimumScreeningThreshold = 75;
export const defaultScreeningThreshold = 90;
export const maximumScreeningThreshold = 100;
export const maxAttachmentCount = 20;
export const maxAttachmentSize = 10485760;
export const defaultPaginationCount = 10;
export const maxRecordsAllowed = 10;
export const bulkScreenThreshold = 5;
export const Note = "note";
export const Match = "match";
export const kycStatusLabel = "kycStatus";
export const kycReview = "kycReview";
export const assignedTo = "assignedTo";
export const riskRating = "riskRating";
export const Person = "Person";
export const Individual = "Individual";
export const Company = "Company";
export const Other = "Other";
export const attachmentTypesAccepted =
  "pdf, doc, docx, txt, xls, xlsx, jpeg or jpg, png, svg, csv, ods";
export const BelgiumEntity = "BE";
export const DenmarkEntity = "DK";
export const NetherlandsEntity = "NL";
export const GermanyEntity = "DE";
export const AustriaEntity = "AT";
export const FranceEntity = "FR";
export const SwedenEntity = "SE";
export const ItalyEntity = "IT";
export const DocumentReport = "Report";
export const keyPartiesUBOsTabs = ["key-parties", "ubos"];
export const apiVersion = "v1";
export const connectApiVersion = "v1";
export const userGuideUrlDEandAT =
  "https://www.creditsafe.com/content/dam/de/booklets/KYC%20Protect%20Benutzerhandbuch-DE.pdf";
export const thresholds = ["75", "80", "85", "90", "95", "100"];
export const maxDownloadRecords = 1000;
export const ASYNC_JOB_STATUS_INTERVAL_MS = 10000;

export const TableMenuItems = {
  edit: "edit",
  assign: "assign",
  delete: "delete",
};

export enum RiskRating {
  NotApplicable = "notApplicable",
  VeryLow = "veryLow",
  Low = "low",
  Medium = "medium",
  High = "high",
  VeryHigh = "veryHigh",
}

export const ProfileStatus = {
  new: "new",
  approved: "approved",
  closed: "closed",
  declined: "declined",
  pending: "pending",
  cancelled: "cancelled",
  referred: "referred",
  approvedReviewDue: "approvedReviewDue",
};

export enum Status {
  New = "new",
  Approved = "approved",
  Declined = "declined",
  Pending = "pending",
  Cancelled = "cancelled",
  Referred = "referred",
  Closed = "closed",
}

export enum UserRoles {
  Admin = "Admin",
  Manager = "Manager",
  Analyst = "Analyst",
  Viewer = "Viewer",
}

export enum UserStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export const ProfileTypes = {
  trust: "trust",
  plc: "plc",
  company: "company",
  partnership: "partnership",
  otherEntity: "otherEntity",
  individual: "individual",
  soleTrader: "soleTrader",
};

export const GROUP_DEFAULT = "Default";
export const GROUP_DEFAULT_GROUP = "Default Group";

export const ProfileTabsTypes = {
  business: "business",
  individual: "individual",
  keyParties: "key-parties",
  ubos: "ubos",
  groupStructure: "group-structure",
  linkedProfiles: "linked-profiles",
  openAlerts: "open-alerts",
  audits: "audits",
  details: "details",
  amlScreen: "aml-screen",
  amlAlerts: "aml-alerts",
  kycAlerts: "kyc-alerts",
};

export const tabCategories = {
  individual: [
    ProfileTabsTypes.individual,
    // ProfileTabsTypes.linkedProfiles, To Do: Un-Comment after the CG-App release
    ProfileTabsTypes.openAlerts,
    ProfileTabsTypes.audits,
  ],
  soleTrader: [
    ProfileTabsTypes.individual,
    ProfileTabsTypes.keyParties,
    ProfileTabsTypes.ubos,
    // ProfileTabsTypes.groupStructure, To Do: Un-Comment after the CG-App release
    // ProfileTabsTypes.linkedProfiles, To Do: Un-Comment after the CG-App release
    ProfileTabsTypes.openAlerts,
    ProfileTabsTypes.audits,
  ],
  others: [
    ProfileTabsTypes.business,
    ProfileTabsTypes.keyParties,
    ProfileTabsTypes.ubos,
    // ProfileTabsTypes.groupStructure, To Do: Un-Comment after the CG-App release
    // ProfileTabsTypes.linkedProfiles, To Do: Un-Comment after the CG-App release
    ProfileTabsTypes.openAlerts,
    ProfileTabsTypes.audits,
  ],
};

export enum SearchType {
  Business = "business",
  Individual = "individual",
}

export enum MonitorSearchType {
  Business = "business",
  Individual = "individual",
  Both = "both",
}

export enum Gender {
  male = "male",
  female = "female",
  notSpecified = "notSpecified",
}

export enum KeyPartyType {
  director = "director",
  shareholder = "shareholder",
  ubo = "ubo",
  shareHolder = "shareHolder",
  other = "other",
}

export enum GenderApi {
  Male = "male",
  Female = "female",
}

export const AmlCategoriesTypes = {
  SAN: "sanctions",
  ENF: "enforcement",
  INS: "insolvency-register",
  SOE: "state-owned-enterprise",
  PEP: "pep",
  POI: "profile-of-interest",
  AM: "adverse-media",
  DD: "disqualified-director",
  PepLinked: "pep-linked",
};

export const AmlTypes = {
  business: "business",
  individual: "individual",
};

export const AmlTabsTypes = {
  about: "about",
  contactAndAddresses: "contact-and-addresses",
  amlCategories: "aml-categories",
  businessLinks: "business-links",
  individualLinks: "individual-links",
  sources: "sources",
  sanctions: "sanctions",
  enforcement: "enforcement",
  insolvencyRegister: "insolvency-register",
  stateOwnedEnterprise: "state-owned-enterprise",
  pep: "pep",
  profileOfInterest: "profile-of-interest",
  adverseMedia: "adverse-media",
  disqualifiedDirector: "disqualified-director",
  pepLinked: "pep-linked",
};

export const amlTabCategories = {
  business: [
    AmlTabsTypes.about,
    AmlTabsTypes.contactAndAddresses,
    AmlTabsTypes.amlCategories,
    AmlTabsTypes.businessLinks,
    AmlTabsTypes.individualLinks,
    AmlTabsTypes.sources,
  ],
  individual: [
    AmlTabsTypes.about,
    AmlTabsTypes.contactAndAddresses,
    AmlTabsTypes.amlCategories,
    AmlTabsTypes.businessLinks,
    AmlTabsTypes.individualLinks,
    AmlTabsTypes.sources,
  ],
};

export const amlBusinessTableheadings = [
  "",
  "amlScreenListDetails.openMatches",
  "amlScreenListDetails.createdOn",
  "",
  "amlScreenListDetails.businessName",
  "amlScreenListDetails.categoriesSearched",
  "amlScreenListDetails.sanctionBodies",
  "amlScreenListDetails.riskRating",
  "amlScreenListDetails.kycStatus",
  "amlScreenListDetails.assignedTo",
  "amlScreenListDetails.monitoring",
];

export const amlIndividualTableheadings = [
  "",
  "amlScreenListDetails.openMatches",
  "amlScreenListDetails.createdOn",
  "",
  "amlScreenListDetails.name",
  "amlScreenListDetails.dateOfBirth",
  "amlScreenListDetails.gender",
  "amlScreenListDetails.categoriesSearched",
  "amlScreenListDetails.sanctionBodies",
  "amlScreenListDetails.riskRating",
  "amlScreenListDetails.kycStatus",
  "amlScreenListDetails.assignedTo",
  "amlScreenListDetails.monitoring",
];

export const amlIndividualDetailProfileHits = [
  "aml:amlIndividualProfileHits.name",
  "",
  "aml:amlIndividualProfileHits.countryLocation",
  "aml:amlIndividualProfileHits.dob",
  "aml:amlIndividualProfileHits.gender",
  "aml:amlIndividualProfileHits.categories",
  "aml:amlIndividualProfileHits.matchPercentage",
  "aml:amlIndividualProfileHits.matchDecision",
  "",
];

export const amlScreenBusinessTableHeadings = [
  "aml:amlBusinessProfileHits.name",
  "aml:amlBusinessProfileHits.countryLocation",
  "aml:amlBusinessProfileHits.categories",
  "aml:amlBusinessProfileHits.matchPercentage",
  "aml:amlBusinessProfileHits.matchDecision",
];

export const amlScreenMatchDecisions = {
  trueMatch: "trueMatch",
  falsePositive: "falsePositive",
  undecided: "undecided",
  discarded: "discarded",
};

export enum PepTiers {
  PepTier1 = "pepTier1",
  PepTier2 = "pepTier2",
  PepTier3 = "pepTier3",
}

export const amlScreenQueryParams = {
  searchId: "searchId",
  amlHitsPageNum: "amlHitsPageNum",
};

export const targetTypes = {
  keyParty: "keyParty",
  profile: "profile",
};

export const asyncAmlJobsStatuses = {
  created: "created",
  processing: "processing",
  completed: "completed",
};

export const auditsFilterTypes = {
  category: "category",
  subCategory: "subcategory",
  action: "action",
};

export const monitoringValidationsTypes = {
  category: "category",
  email: "email",
  emailCount: "emailCount",
};

export const tabsToDisplayWhenLocked = [
  {
    id: "business",
    label: "profile.tabs.business",
    noOfItems: 0,
  },
  {
    id: "audits",
    label: "profile.tabs.audits",
    noOfItems: 0,
  },
];

export const subTabsToDisplayWhenLocked = [
  {
    id: "details",
    label: "profile.subTabs.details",
    noOfItems: 0,
  },
];

export const profileSections = {
  profileDetails: "profileDetails",
};

export const supportedAttachmentTypes = [
  "application/pdf",
  "text/csv",
  "application/vnd.oasis.opendocument.spreadsheet",
  "application/msword",
  "image/svg+xml",
  "image/png",
  "text/plain",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
];

export const supportedAttachmentTypesToUpload = [
  "pdf",
  "doc",
  "docx",
  "txt",
  "xls",
  "xlsx",
  "jpeg",
  "jpg",
  "png",
  "svg",
  "csv",
  "ods",
];

export const nonIndividualDataSet = ["stateOwnedEnterprise"];
export const nonBusinessDataSet = ["disqualifiedDirector"];

export const getAddress = (
  isRegistered = false
): {
  buildingDetails: string;
  id: string;
  city: string;
  region: string;
  postalCode: string;
  profileId: string;
  street: string;
  countryCode: string;
  type: string;
  description: string;
} => {
  return {
    buildingDetails: "",
    id: "",
    city: "",
    region: "",
    postalCode: "",
    profileId: "",
    street: "",
    countryCode: "",
    type: isRegistered ? "registered" : "",
    description: "",
  };
};

export const addressTypes = {
  other: "Other",
  registered: "registered",
};

export const shouldRemoveDataSets = {
  sanCurrent: "SAN-CURRENT",
  pepCurrent: "PEP-CURRENT",
  sanFormer: "SAN-FORMER",
  pepFormer: "PEP-FORMER",
  soeCurrent: "SOE-CURRENT",
  soeFormer: "SOE-FORMER",
  pepLinked: "PEP-LINKED",
};

export const kycAlertsStatuses = {
  open: "open",
  closedProcessed: "closedProcessed",
  closedUnprocessed: "closedUnprocessed",
};

export const NotEnoughCreditsAvailable = "NotEnoughCreditsAvailable";

export const sources = {
  upp: "UPP",
  app: "app",
  complianceAlert: "complianceAlert",
};

export const Search = "search";
export const Hit = "hit";

export const regionMap: Record<string, string> = {
  eas: "East Asia and Pacific",
  ecs: "Europe and Central Asia",
  lcn: "Latin America and the Caribbean",
  mea: "Middle East and North Africa",
  nac: "North America",
  sas: "South Asia",
  ssf: "Sub-Saharan Africa",
  glb: "Global",
};

export const amlCategoriesForIndividual = [
  "sanctionsCurrent",
  "sanctionsFormer",
  "enforcement",
  "pepCurrent",
  "pepFormer",
  "pepLinked",
  "insolvencyRegister",
  "adverseMedia",
  "disqualifiedDirector",
  "profileOfInterest",
];

export const amlCategoriesForBusiness = [
  "sanctionsCurrent",
  "sanctionsFormer",
  "enforcement",
  "stateOwnedEnterpriseCurrent",
  "stateOwnedEnterpriseFormer",
  "pepLinked",
  "insolvencyRegister",
  "adverseMedia",
  "profileOfInterest",
];

export const features = {
  monitorSearch: "monitor_search",
  monitorSearchResultSubtab: "monitor_search_results_subtab",
  businessAndIndividualLink: "business_and_individual_link",
  filterByDob: "filter_by_dob",
  fullAmlPdf: "full_aml_pdf",
  denmarkUBOMapping: "profile_import_denmark_ubo_mapping",
  rechargeSummary: "DISPLAY_RECHARGE_SUMMARY",
  enableAuthorization: "enable_authorization",
};
